<template>
  <div
    v-if="caption || credit"
    :class="$b('footer')"
  >
    <figcaption :class="[$b('caption'), 't-body-sm']">
      {{ caption || '' }}
    </figcaption>
    <span
      v-if="credit"
      :class="[$b('credit'), 't-body-sm']"
    >
      {{ credit }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ArticleImageFooter',

  props: {
    caption: {
      type: String,
      default: null,
    },

    credit: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="postcss">
.ArticleImageFooter__footer {
  @apply flex justify-between;

  @screen lg {
    @apply space-x-xs;
  }

  @screen lgMax {
    @apply flex-col space-y-xxs;
  }
}

.ArticleImageFooter__caption {
  max-width: calc(416 / 13 * 1em);
}

.ArticleImageFooter__credit {
  @apply opacity-80 italic;
}
</style>
